import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { getStatusMeta, type AdminTone } from './status';

export interface StatusChipProps extends HTMLAttributes<HTMLSpanElement> {
  /** Raw record status (e.g. a `jobs.status`). Supplies tone + label. */
  status?: string | null;
  /** Explicit tone; overrides the status tone. */
  tone?: AdminTone;
  /** Show the leading dot (default true). */
  dot?: boolean;
  /** Custom label; defaults to the status label. */
  children?: ReactNode;
}

/** Small pill such as "• Completed" — the Fikri "• Finished" chip. */
export function StatusChip({ status, tone, dot = true, children, className, ...rest }: StatusChipProps) {
  const meta = getStatusMeta(status);
  return (
    <span
      className={cn('adm-chip', `adm-chip--${tone ?? meta.tone}`, dot && 'adm-chip--dot', className)}
      {...rest}
    >
      {children ?? meta.label}
    </span>
  );
}
